import { Directive, ElementRef, inject, input, effect } from '@angular/core';
import { FiEmojiService } from './fi-emoji.service';
import { TEmojiSet } from './fi-emoji';
import { IReactionData } from '@fi-shared/fi-likes/fi-likes';

@Directive({
    selector: '[fiEmojiImage]',
    standalone: false,
})
export class FiEmojiImageDirective {
    private readonly host = inject(ElementRef<HTMLElement>);
    private readonly fiEmojiService = inject(FiEmojiService);

    readonly fiEmojiImage = input.required<IReactionData>();
    readonly fiEmojiSet = input<TEmojiSet>('apple');
    readonly fiEmojiImageSize = input<number>(20);

    constructor() {
        effect(() => {
            const fiEmojiSet = this.fiEmojiSet();
            const unifiedCode = this.fiEmojiImage()?.Unified;
            const img = this.fiEmojiService.getEmojiByUnifiedCode(unifiedCode, fiEmojiSet, this.fiEmojiImageSize());

            /*
            let emoji: IReactionData = this.fiEmojiImage();
            const fiEmojiSet = this.fiEmojiSet();
            if (typeof emoji === 'string') {
                emoji = JSON.parse(emoji);
            }

            const img =
                !isNullOrUndefined(emoji.unified) && emoji.unified.length > 0
                    ? this.fiEmojiService.getEmojiByUnifiedCode(emoji.unified, fiEmojiSet, this.fiEmojiImageSize())
                    : this.fiEmojiService.getEmojiImgElement(emoji.sheet, emoji);
                    */

            this.host.nativeElement.replaceChildren(img);
        });
    }
}
